import type { PackageResponse } from '../../types/packages';

/** Spec 081b — the customer-app copy the admin phone preview draws, EN and AR (prices stay LTR). */

export type PreviewLocale = 'en' | 'ar';

export interface PreviewText {
  ends: string;
  from: string;
  included: string;
  choose: string;
  required: string;
  youSave: string;
  packagePrice: string;
  minutes: (n: number) => string;
  promo: string;
}

export const PREVIEW_TEXT: Record<PreviewLocale, PreviewText> = {
  en: {
    ends: 'Ends',
    from: 'from',
    included: "What's included",
    choose: 'Choose',
    required: 'Required',
    youSave: 'You save',
    packagePrice: 'Package price',
    minutes: (n) => `About ${n} min`,
    promo: 'You can still add a promo code at checkout',
  },
  ar: {
    ends: 'ينتهي',
    from: 'ابتداءً من',
    included: 'ماذا تشمل الباقة',
    choose: 'اختر',
    required: 'مطلوب',
    youSave: 'توفّر',
    packagePrice: 'سعر الباقة',
    minutes: (n) => `حوالي ${n} دقيقة`,
    promo: 'يمكنك إضافة رمز ترويجي عند الدفع',
  },
};

/** Arabic text when the locale is AR and it exists, else the English text (D-090 Q2 fallback). */
export function pick(locale: PreviewLocale, en: string | null | undefined, ar: string | null | undefined): string {
  return (locale === 'ar' && ar?.trim() ? ar : en) ?? '';
}

/** Which Arabic fields fall back to English (shown under the phone). */
export function arabicFallbacks(p: Pick<PackageResponse, 'nameAr' | 'descriptionEn' | 'descriptionAr' | 'items'>): string[] {
  const out: string[] = [];
  if (!p.nameAr?.trim()) out.push('name');
  if (p.descriptionEn?.trim() && !p.descriptionAr?.trim()) out.push('description');
  if (p.items.some((i) => !i.nameAr?.trim())) out.push('service names');
  return out;
}
